import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
export function UitkRadioButtonGroup({
  children,
  errorMessage,
  group,
  onChange,
  selected,
  className,
  style
}) {
  function handleChange(e) {
    if (onChange)
      onChange(e);
  }
  const childProps = {
    name: group,
    onChange: handleChange
  };
  const wrapperClassNames = classNames("uitk-radio-button-group", className);
  const errorClassNames = classNames("uitk-radio-button-error");
  return /* @__PURE__ */ React.createElement("fieldset", { className: wrapperClassNames, style }, /* @__PURE__ */ React.createElement("legend", { className: "is-visually-hidden" }, group), errorMessage && /* @__PURE__ */ React.createElement("p", { className: errorClassNames }, errorMessage), React.Children.map(children, (child) => {
    const value = child?.props?.value;
    const checked = selected === value;
    return React.cloneElement(child, {
      ...childProps,
      checked
    });
  }));
}
